export default "__VITE_ASSET__B8H6rMfR__"